import React from 'react';

const NoDataState = () => (
  <div className="text-center pt-lg mx-auto" style={{ maxWidth: 340 }}>
    <p className="m-b text-xxs text-normal text-quiet">
      Apptopia has data on over 2,700 SDKs but we seem to be missing the one you are looking for.
      Contact sales and we&apos;ll be happy to get that one added for you.
    </p>
  </div>
);

export default NoDataState;
